<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', 'Clients')
</script>

<template>
  <q-page padding> Clients </q-page>
</template>
